import { handleResponse, API_BASE_URL, getAuthHeader } from '../api';

export const customFields = {
  // Get all custom fields for current user
  getAll: async () => {
    const headers = await getAuthHeader('GET');
    const response = await fetch(`${API_BASE_URL}/custom-fields`, {
      headers,
      credentials: 'include'
    });
    return handleResponse(response, 'GET');
  },

  // Create a new custom field
  create: async (data) => {
    const headers = await getAuthHeader('POST');
    const response = await fetch(`${API_BASE_URL}/custom-fields`, {
      method: 'POST',
      headers,
      body: JSON.stringify(data),
      credentials: 'include'
    });
    return handleResponse(response, 'POST');
  },

  // Update a custom field
  update: async (id, data) => {
    const headers = await getAuthHeader('PUT');
    const response = await fetch(`${API_BASE_URL}/custom-fields/${id}`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(data),
      credentials: 'include'
    });
    return handleResponse(response, 'PUT');
  },

  // Delete a custom field
  delete: async (id) => {
    const headers = await getAuthHeader('DELETE');
    const response = await fetch(`${API_BASE_URL}/custom-fields/${id}`, {
      method: 'DELETE',
      headers,
      credentials: 'include'
    });
    return handleResponse(response, 'DELETE');
  },

  // Get custom field values for multiple coins
  getValuesBulk: async (coinIds) => {
    const headers = await getAuthHeader('GET');
    const response = await fetch(`${API_BASE_URL}/custom-fields/values/bulk?coinIds=${coinIds.join(',')}`, {
      headers,
      credentials: 'include'
    });
    return handleResponse(response, 'GET');
  },

  // Get custom field values for a single coin
  getValues: async (coinId) => {
    const headers = await getAuthHeader('GET');
    const response = await fetch(`${API_BASE_URL}/custom-fields/values/${coinId}`, {
      headers,
      credentials: 'include'
    });
    return handleResponse(response, 'GET');
  },

  // Set/update custom field values for a coin
  setValues: async (coinId, values) => {
    const headers = await getAuthHeader('POST');
    const response = await fetch(`${API_BASE_URL}/custom-fields/values/${coinId}`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ values }),
      credentials: 'include'
    });
    return handleResponse(response, 'POST');
  }
};
